import { Box, Stack, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { InfoTooltip } from '../../../consts'
import { CAMPAIGN_DIRECTION, CAMPAIGN_TYPE_OPTIONS, PLAYLIST_FILTER_INFO_DESCRIPTIONS, PLAYLIST_FILTERS_OPTIONS } from '../../../helpers/constant'
import { useThemeMode } from '../../theme'
import CommonSelectComponent from './common-select'

const TableFilter = ({ filterTypes, defaultFilterValues, onChange, companyListOptions, spinner }) => {
    const [initialValues, setInitialValues] = React.useState(defaultFilterValues || {});
    const { themeMode } = useThemeMode();

    useEffect(() => {
        if (onChange) {
            if (Object.keys(initialValues).length) {
                onChange(initialValues)
            }
        }
    }, [initialValues])

    return (<Box display="flex"
        flexWrap="wrap"
        flexDirection="row"
        gap={2}
        marginRight="auto"
        flexGrow={1}
    >
        {filterTypes.campaignType ? <Typography component="div" flexGrow={1}>
            <CommonSelectComponent
                htmlId={"types-filter"}
                label="Types"
                Placeholder={"All Types"}
                spinner={spinner}
                filterOptions={CAMPAIGN_TYPE_OPTIONS}
                selected={initialValues.campaignType}
                setSelected={(type) => {
                    setInitialValues({ ...initialValues, campaignType: type })
                }}
            />
        </Typography> : ""}
        {filterTypes.callDirection ? <Typography component="div" flexGrow={1}>
            <CommonSelectComponent
                htmlId={"direction-filter"}
                label="Direction"
                Placeholder={"All Direction"}
                spinner={spinner}
                filterOptions={CAMPAIGN_DIRECTION}
                selected={initialValues.callDirection}
                setSelected={(direction) => {
                    setInitialValues({ ...initialValues, callDirection: direction })
                }}
            />
        </Typography> : ""}
        {filterTypes.playListBookmark ? <Stack direction="row" gap={.5} alignItems="center" flexGrow={1}>
            <CommonSelectComponent
                htmlId={"bookmark-filter"}
                label="Bookmark"
                spinner={spinner}
                filterOptions={PLAYLIST_FILTERS_OPTIONS}
                selected={initialValues.playListBookmark}
                setSelected={(bookmark) => {
                    setInitialValues({ ...initialValues, playListBookmark: bookmark })
                }}
            />
            <InfoTooltip info={PLAYLIST_FILTER_INFO_DESCRIPTIONS[initialValues.playListBookmark]} themeMode={themeMode} />
        </Stack> : ""}
        {filterTypes.groupName ? <Stack direction="row" gap={.5} alignItems="center" flexGrow={1}>
            <CommonSelectComponent
                htmlId={"group-filter"}
                label="Companies"
                Placeholder={"All Companies"}
                spinner={spinner}
                filterOptions={companyListOptions}
                selected={initialValues.groupName}
                setSelected={(group) => {
                    setInitialValues({ ...initialValues, groupName: group })
                }}
                labelKey="name"
                valueKey="internalname"
            />
            <InfoTooltip info={"Select the company to filter and view its associated users"} themeMode={themeMode} />
        </Stack> : ""}
    </Box>)
}

export default TableFilter